export default __webpack_public_path__ + "static/brunos-pizza@2x-1e6faf84d8b70b5a827f266cd58410d7.png";